import React, { useEffect, useState } from "react";
// CheckSquare, Square: re-add with the multi-select checkbox below
import { Pencil, Trash2 } from "lucide-react";
import { AnimatePresence } from "framer-motion";
import { ItemUI } from "../types/item";
import EditItemModal from "../components/EditItemModal";
import AddItemIcon from "../components/icons/AddItemIcon";
import ItemRowShell from "./ItemRowShell";

// the + buttons straddle the row's left edge, half outside it (above the
// first row, and below each row)
const edgeStyle: React.CSSProperties = {
  position: "absolute",
  left: -10,
  zIndex: 1,
};

interface InitItemRowProps {
  item: ItemUI;
  setItem: (item: ItemUI) => void;
  // + above the row — only on the first one
  onAddFirst?: () => void;
  onAddAfter: () => void;
  onDelete: () => void;
  // just added: open straight into the "Add item" modal
  autoEdit: boolean;
  onAutoEditDone: () => void;
  // multi-select for the bulk editor (checkbox currently commented out)
  selected: boolean;
  onToggleSelect?: () => void;
}

// An item while the check is being built (no id in the URL): edit and delete
// on the right, + buttons to add rows above/below.
const InitItemRow: React.FC<InitItemRowProps> = ({
  item,
  setItem,
  onAddFirst,
  onAddAfter,
  onDelete,
  autoEdit,
  onAutoEditDone,
  selected,
  onToggleSelect,
}) => {
  // "add" when opened for a just-added item, "edit" from the pencil
  const [editing, setEditing] = useState<"add" | "edit" | null>(null);

  useEffect(() => {
    if (autoEdit) {
      setEditing("add");
      onAutoEditDone();
    }
  }, [autoEdit, onAutoEditDone]);

  return (
    <ItemRowShell
      item={item}
      variant="init"
      overlays={
        <>
          {onAddFirst && (
            <AddItemIcon
              onClick={onAddFirst}
              style={{ ...edgeStyle, top: -10 }}
            />
          )}
          <AddItemIcon
            onClick={onAddAfter}
            style={{ ...edgeStyle, bottom: -10 }}
          />
          {/* lets the modal play its close animation */}
          <AnimatePresence>
            {editing && (
              <EditItemModal
                key="edit"
                item={item}
                isNew={editing === "add"}
                onSave={(name, price) => setItem({ ...item, name, price })}
                handleClose={() => setEditing(null)}
              />
            )}
          </AnimatePresence>
        </>
      }
    >
      <Pencil className="item-edit" onClick={() => setEditing("edit")} />
      <Trash2 className="item-delete" onClick={onDelete} />
        {/* multi-select checkbox, replaced by the trash icon for now
        {onToggleSelect &&
          (selected ? (
            <CheckSquare
              className="item-select checked"
              onClick={onToggleSelect}
            />
          ) : (
            <Square className="item-select" onClick={onToggleSelect} />
          ))} */}
    </ItemRowShell>
  );
};

export default InitItemRow;
